module.exports = __webpack_public_path__ + "c8f8d2cba6e2223cba5202d004f64db3.svg";